import { addDays, eachDayOfInterval, isAfter, isToday, isWeekend } from 'date-fns';

/**
 * Returns true, if the given date is the last trading day of the given market.
 */
export function isDateIsTheLastTradingDay({
  market,
  dateStr,
  formatDate,
  nonTradingDays,
  now,
}: {
  market: string;
  dateStr: string | undefined;
  formatDate: (date: Date) => string;
  nonTradingDays: Record<string, Array<string>>;
  now?: Date;
}) {
  if (!dateStr) {
    return false;
  }
  const end = addDays(now || new Date(), -1);
  const lastTradeDate = new Date(dateStr);
  // if last trade date is a weekend or the same as the end date
  if (isWeekend(lastTradeDate) || lastTradeDate.getDay() === 0) {
    return false;
  }
  // if last trade date is after the end date
  if (isAfter(lastTradeDate, end)) {
    return false;
  }

  const marketNonTradingDays = nonTradingDays[market] || [];
  const tradingDaysBetweenNowAndLastTradeDate: Array<Date> = eachDayOfInterval({
    start: lastTradeDate,
    end,
  });
  const filteredDays = tradingDaysBetweenNowAndLastTradeDate
    .slice(1)
    .filter(date => !marketNonTradingDays.includes(formatDate(date)))
    .filter(date => !isWeekend(date));

  return filteredDays.length === 0;
}

export function isDateIsToday({ dateStr }: { dateStr: string | undefined }) {
  if (!dateStr) {
    return false;
  }
  const date = new Date(dateStr);
  return isToday(date);
}
